<template>
  <a-modal
    class="table-list-modal"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="推广资料"
    :footer="null"
    @cancel="$emit('onCancel')"
  >
    <a-table
      style="margin-bottom:50px;"
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    />
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '类型',
          dataIndex: 'link_datas.obj_type_text',
        },
        {
          title: '标题',
          dataIndex: 'link_datas.name',
        },
		{
		  title: '关联产品',
		  dataIndex: 'product.title',
		},
		{
		  title: '使用次数',
		  dataIndex: 'allow_use_times',
		  customRender: (value, row, index) => {
		    const obj = {
		      children: value===0?'不限制次数':value,
			  attrs: {},
		    };
		    // if(row.isMerge){
		    //   obj.attrs.rowSpan  = row.rowSpan;
		    // }else{
		    //   obj.attrs.rowSpan  = 0;
		    // }
		    return obj;
		  },
		  },
      ],
    };
  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="scss" scoped>

</style>